import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/merchant/:id',
    name: 'MerchantDetails',
    components: {
      default: () => import(/* webpackChunkName: "merchant" */ '../views/MerchantDetails.vue'),
      nav: () => import(/* webpackChunkName: "merchant-nav" */ '../views/header/MerchantDetailsHeader.vue'),
    },
  },
  {
    path: '/merchant/:id/checkout',
    name: 'Checkout',
    components: {
      default: () => import(/* webpackChunkName: "checkout" */ '../views/Checkout.vue'),
      nav: () => import(/* webpackChunkName: "checkout-nav" */ '../views/header/CheckoutHeader.vue'),
    },
  },
  {
    path: '/merchant/:id/order/:orderId',
    name: 'Receipt',
    components: {
      default: () => import(/* webpackChunkName: "receipt" */ '../views/Receipt.vue'),
      nav: () => import(/* webpackChunkName: "receipt-nav" */ '../views/header/ReceiptHeader.vue'),
    },
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
